var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusFirstStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 32,
    viewBox: "0 0 150 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2842_2776",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 1.79086 1.79087 0 4.00001 0H135.263C136.456 0 137.587 0.532544 138.347 1.45229L148.261 13.4523C149.483 14.9311 149.483 17.0689 148.261 18.5477L138.347 30.5477C137.587 31.4675 136.456 32 135.263 32H4C1.79086 32 0 30.2091 0 28V4Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 1.79086 1.79087 0 4.00001 0H135.263C136.456 0 137.587 0.532544 138.347 1.45229L148.261 13.4523C149.483 14.9311 149.483 17.0689 148.261 18.5477L138.347 30.5477C137.587 31.4675 136.456 32 135.263 32H4C1.79086 32 0 30.2091 0 28V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.261 13.4523L147.49 14.0892L147.49 14.0892L148.261 13.4523ZM148.261 18.5477L147.49 17.9108L147.49 17.9108L148.261 18.5477ZM138.347 30.5477L139.118 31.1846L138.347 30.5477ZM138.347 1.45229L139.118 0.815361L138.347 1.45229ZM135.263 -1H4.00001V1H135.263V-1ZM137.576 2.08922L147.49 14.0892L149.032 12.8154L139.118 0.815361L137.576 2.08922ZM147.49 14.0892C148.407 15.1983 148.407 16.8017 147.49 17.9108L149.032 19.1846C150.559 17.3362 150.559 14.6638 149.032 12.8154L147.49 14.0892ZM147.49 17.9108L137.576 29.9108L139.118 31.1846L149.032 19.1846L147.49 17.9108ZM4 33H135.263V31H4V33ZM-1 4V28H1V4H-1ZM137.576 29.9108C137.006 30.6006 136.158 31 135.263 31V33C136.755 33 138.168 32.3343 139.118 31.1846L137.576 29.9108ZM4.00001 -1C1.23859 -1 -1 1.23857 -1 4H1C1 2.34315 2.34315 1 4.00001 1V-1ZM4 31C2.34315 31 1 29.6569 1 28H-1C-1 30.7614 1.23858 33 4 33V31ZM135.263 1C136.158 1 137.006 1.39941 137.576 2.08922L139.118 0.815361C138.168 -0.33432 136.755 -1 135.263 -1V1Z",
    fill: "#C1C9D2",
    mask: "url(#path-1-inside-1_2842_2776)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusFirstStep);
export default __webpack_public_path__ + "static/media/status-first-step.cd3d19a5b88e3f0460d3a8540c752ed0.svg";
export { ForwardRef as ReactComponent };